<template>
  <PropertiesTable
    :properties="editableCompany.properties"
    :editablePropertyOrigin="editablePropertyOrigin"
    @cancel="isEditFormOpen=false"
    @addNewProperty="addNewProperty"
    @saveProperty="saveProperty"
    @deleteProperty="deleteProperty">
  </PropertiesTable>
</template>

<script>
import PropertiesTable from "../../Shared/PropertiesTable";
import { PropertyOrigin } from "../../../models/PropertyOrigin";
import _ from "lodash";

export default {
    components: { PropertiesTable },
    props: {
        company: {
            type: Object,
            default: function() {
                return null;
            }
        }
    },
    data() {
        return {
            editableCompany: _.cloneDeep(this.company),
            editablePropertyOrigin: PropertyOrigin.CompanyConfiguration,
            selectedProperty: null,
            isEditFormOpen: false
        };
    },
    watch: {
        company(val) {
            this.editableCompany = (!val) ? {} : _.cloneDeep(val);
        }
    },
    methods: {
        addNewProperty: function(property, eventTargetId) {
            this.$emit("addNewProperty", property, eventTargetId);
        },
        saveProperty: function(property, eventTargetId) {
            this.$emit("saveProperty", property, eventTargetId);
        },
        deleteProperty: function(property, eventTargetId) {
            this.$emit("deleteProperty", property, eventTargetId);
        }
    }
};
</script>
